import { createContext, useContext, ReactNode } from "react";
import { useMarketingAssets, type MarketingAssetsData } from "../hooks/useMarketingAssets";
import { EntityRecord } from "@/types/entity";

const MarketingContext = createContext<MarketingAssetsData | undefined>(undefined);

interface MarketingProviderProps {
  children: ReactNode;
  entityRecord: EntityRecord;
}

export const MarketingProvider = ({ children, entityRecord }: MarketingProviderProps) => {
  const data = useMarketingAssets(entityRecord);

  return (
    <MarketingContext.Provider value={data}>
      {children}
    </MarketingContext.Provider>
  );
};

export const useMarketingContext = () => {
  const context = useContext(MarketingContext);
  if (context === undefined) {
    throw new Error("useMarketingContext must be used within a MarketingProvider");
  }
  return context;
};
